import Form from "react-bootstrap/Form";
import React, {useState} from "react";
import {ResponseAllTimesbyUser} from "../API/response/worktimetracking";
import {useSelector} from "react-redux";
import {Link, useParams} from "react-router-dom";
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import '../css/worktimetracking.css'
import {init2} from "../../../@WUM/core/form-serilizer/seriliaze/Formserialize";
import {getToken, setNavi} from "../../../@WUM/core/Function/index";
import {ApiURL, IntlMessage, IntlMessageValue, UniSpinner, WUMCalender} from "../../../@WUM/core/Elements/index";
import UniModal from "../../../@WUM/core/component/const/UniModal";
import {ResponseSettings} from "../API/response/settingstimetracking";
import {data} from "jquery";
import settings from "./settings";
import {ColorMaker} from "./Configs/ColorMaker";
import {LegendList} from "./PlanerComponents/Elements/LegendList";
const WorkTimeTrackingCalender = (props:{value:any}) =>{
    setNavi({
        route:'/calender/worktime/tracking/software/'
    })

    const SunEditorConfig = () => {
        return [
            // Default
            ['italic','bold','outdent', 'indent','align', 'list','link']
        ]
    }
    const userId = localStorage.getItem('userid')
    const { id } = useParams<{ id: string }>()
    const Store = useSelector((state: any) => state)
    const [fetchData, setFetchData] = useState(0);
    const [load,setLoad] = useState(false);
    const [value, setValue] = useState('');
    const response = ResponseAllTimesbyUser(userId,fetchData);
    const settingsData = ResponseSettings(userId || "")

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const successForm = (result:any) => {
        setFetchData(Date.now())
        setValue('')
        handleClose()
    }

    const Reloadsuccess = () => {
        setFetchData(Date.now())
        setLoad(false)
    }

    const errorForm = (error:any)=> {
        handleClose()
    }


    const setEditorContent = (value:any,textarea?:any) =>{
        setValue(value)
        if(textarea !== undefined) {
            (document.getElementById('descriptionTextarea') as HTMLTextAreaElement).value = value
        }
    }

    const CloseDynmaikModal = () => {
        handleClose();
    }

    const calculateTimeDifferenceinMili = (d1:any, d2:any) => {
        const startTime = new Date('2012/10/09 '+d1).getTime();
        const endTime = new Date('2012/10/09 '+d2).getTime();
        // Differenz berechnen
        var diff = endTime - startTime;

        return diff;

    };

    const handlesubmit = (e:any) => {
        const form = e.currentTarget
        e.preventDefault()
        let Data = init2(form)
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Authorization", "Bearer "+ getToken());

        var raw = JSON.stringify(
            {
                "grund": Data.grund,
                "time_start": Data.time_start+':00',
                "time_end": Data.time_end+':00',
                "dauer": calculateTimeDifferenceinMili(Data.time_start,Data.time_end)/1000,
                "date": Data.date,
                "user": localStorage.getItem('userid')
            }
        );

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
        };

       fetch(ApiURL() +"work/save/timetracking/", requestOptions)
            .then(response => response.text())
            .then(result => {successForm(result)})
            .catch(error => errorForm(error));
    };

    let DataHolder = [];

    const test = (content:any) => {
        console.log(content)
    }

    if (settingsData === undefined) {
        return <UniSpinner />;
    }

    if (typeof settingsData == "boolean") {
        return <div>Fehler beim Laden der Einstellungen.</div>;
    }

    const breaktimeTotal =
        (Number(settingsData.breaktime) || 0) *
        (Array.isArray(settingsData.workingDays) ? settingsData.workingDays.length : 0) / 60;

    if (typeof response !== "boolean" && response?.length > 0) {

        for (let x = 0; x < response.length; x++) {

            let dataSet = response[x]

            const colors = ColorMaker(
                dataSet.grund === 'Urlaub'
                    ? 'vacation'
                    : dataSet.grund === 'Pause'
                        ? 'pause'
                        : dataSet.grund === 'Unterbrechung'
                            ? 'interruption'
                            : 'working'
            )

            DataHolder.push(
                {
                    date: dataSet.date + ' ' + dataSet.time_start,
                    enddate: dataSet.date + ' ' + dataSet.time_end,
                    title: IntlMessageValue('de','wtt.'+dataSet.grund,Store),
                    time: dataSet.dauer * 1000,
                    on_Click: test,
                    content: 'test3466',
                    color: colors.bg,
                    breack: (dataSet.grund === 'Pause' ? true : false),
                    tcolor: colors.text,
                }
            )
        }
    }

    return(
        <>
            <div className={'ticketsystem'} style={{paddingLeft: '25px',paddingRight: '25px'}}>
                <Card className={'CardTargetWorkTracking'}>
                    <Card.Body className={'pb-0'}>
                <h3 >
                    {IntlMessageValue('de', 'wtt.headline', Store)}
                    <Button variant="secondary" className={'float-end ml-3'} style={{position:'relative',right:'5px',zIndex:'96'}}
                            onClick={(e) => Reloadsuccess()}>
                                        <span className="material-icons me-1" style={{verticalAlign:'bottom'}}>
                                            autorenew
                                        </span>
                        <IntlMessage messageId={"common.reload.page"} Store={Store} />
                    </Button>

                    <UniModal
                        headline={IntlMessageValue('de', 'wtt.add.time.entry', Store)} ClassOpenButton={'float-end'}
                        ClassSaveButton={'float-end'}
                        field={
                        <>
                            <Row>
                                <Col>
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                        <Form.Label>{IntlMessageValue('de', 'wtt.activity', Store)}</Form.Label>
                                        <Form.Select aria-label="Default select example" name={'grund'} required={true}>
                                            <option label={IntlMessageValue('de', 'wtt.select.activity', Store)} />
                                            <option value="Arbeit">{IntlMessageValue('de', 'wtt.Arbeit', Store)}</option>
                                            <option value="Pause">{IntlMessageValue('de', 'wtt.Pause', Store)}</option>
                                            <option value="Urlaub">{IntlMessageValue('de', 'wtt.Urlaub', Store)}</option>
                                            <option value="Unterbrechung">{IntlMessageValue('de', 'wtt.Unterbrechung', Store)}</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                        <Form.Label>{IntlMessageValue('de', 'common.date', Store)}</Form.Label>
                                        <Form.Control type="date" name={'date'} />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                        <Form.Label>{IntlMessageValue('de', 'wtt.time_start', Store)}</Form.Label>
                                        <Form.Control type="time" name={'time_start'} />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                        <Form.Label>{IntlMessageValue('de', 'wtt.time_end', Store)}</Form.Label>
                                        <Form.Control type="time" name={'time_end'} />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </>
                    }
                  saveButtonLabel={IntlMessageValue('de', 'common.save', Store)} handlesubmit={handlesubmit}
                  CloseButtonLabel={IntlMessageValue('de', 'common.close', Store)}
                  ButtonLabel={<>
                      <span className="material-icons pr-2" style={{verticalAlign:'bottom'}}>
                            add
                     </span>
                      {IntlMessageValue('de', 'wtt.button.timeEntry', Store)}</>
                    }
                                />


                </h3>
                        <LegendList
                            items={['working', 'vacation', 'pause', 'interruption']}
                            labelFn={IntlMessageValue}
                            store={Store}
                        />
                    </Card.Body>
                </Card>

                <WUMCalender data={DataHolder} All={settingsData?.worktime} label={IntlMessageValue('de', 'wtt.week.work.time', Store)}
                             highlightStart={settingsData?.flexitimeStart} highlightEnd={settingsData?.flexitimeEnd} highlightName={"Gleitzeit"}
                             breackAll={breaktimeTotal} breacklabel={IntlMessageValue('de', 'wtt.week.break.time', Store)} dontShow={false} />



            </div>
        </>
    )
}

export default WorkTimeTrackingCalender;


